import React from "react";
import { Redirect, Route } from "react-router-dom";

import { ExternalRedirect } from "../ExternalRedirect";
import { protectedRoutePropTypes } from "./ProtectedRoute.propTypes";
import { ProtectedRouteProps } from "./ProtectedRoute.types";

/**
 * The ProtectedRoute component wraps react-router-dom Route with conditional redirecting.
 */
export const ProtectedRoute = (props: ProtectedRouteProps) => {
  const { children, redirectPath, redirectType = "internal", shouldRender, ...options } = props;

  const renderRedirect = () => {
    let redirectElement = null;

    if (redirectType === "internal") {
      redirectElement = <Redirect to={redirectPath} />;
    } else if (redirectType === "external") {
      redirectElement = <ExternalRedirect to={redirectPath} />;
    }

    return redirectElement;
  };

  return <Route {...options} render={() => (shouldRender ? children : renderRedirect())} />;
};

ProtectedRoute.displayName = "ProtectedRoute";
ProtectedRoute.propTypes = protectedRoutePropTypes;
